<template>
  <label :style="styles" :class="hidden ? 'hidden' : ''">
    <input
      name="file"
      type="file"
      :accept="accept"
      multiple="false"
      @change="handleFile"
    />
    {{ label }}
  </label>
</template>

<script>
export default {
  name: "Upload",
  props: {
    label: { default: "Foto uploaden" },
    accept: { default: "image/*" },
    hidden: Boolean,
    styles: {
      type: Object,
      default: () => {
        return { width: "calc(100% - 3rem)" };
      }
    }
  },
  beforeCreate: async function() {},
  methods: {
    handleFile: function(e) {
      this.$emit("fileSelect", e.target.files);
    }
  }
};
</script>

<style scoped>
p {
  margin: 1rem 0 0;
  text-align: left;
}

input {
  display: none;
}

label {
  cursor: pointer;
  display: inline;
}
</style>
